import { Flex, HStack, IconButton, Tooltip } from '@chakra-ui/react';
import CanopyInput from '../../../canopy-ui-components/components/CanopyInput/CanopyInput';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
// import ActClose from '../../../../../canopy-ui-components/components/Icons/ActClose';
import ActClose from './../../../canopy-ui-components/components/Icons/ActClose';

export type WorkbookDetailsType = {
    subMenuKey: string;
    workbookPath: string;
    defaultView?: string;
};
type Props = {
    total: number;
    data: WorkbookDetailsType;
    mappingsIndex: number;
    workbookIndex: number;
    globalProps: GlobalProps;
    updateWorkbookDetails: (
        workbookDetails: WorkbookDetailsType,
        mappingsIndex: number,
        workbookIndex: number
    ) => void;
    handleDeleteWorkbook: (
        mappingsIndex: number,
        workbookIndex: number
    ) => void;
};
function WorkbookDetails({
    total,
    data,
    mappingsIndex,
    workbookIndex,
    updateWorkbookDetails,
    handleDeleteWorkbook,
    globalProps,
}: Props) {
    const { t } = globalProps;
    const currentColors = useCurrentColors();
    const handleSubMenuChange = (value: string) => {
        let workbookDetails = {
            subMenuKey: value,
            workbookPath: data.workbookPath,
            defaultView: data.defaultView,
        };
        updateWorkbookDetails(workbookDetails, mappingsIndex, workbookIndex);
    };
    const handleWorkbookPathChange = (value: string) => {
        let workbookDetails = {
            subMenuKey: data.subMenuKey,
            workbookPath: value,
            defaultView: data.defaultView,
        };
        updateWorkbookDetails(workbookDetails, mappingsIndex, workbookIndex);
    };
    return (
        <HStack
            width="100%"
            spacing="20px"
            justify="center">
            <CanopyInput
                height="30px"
                fontSize="md"
                backgroundColor="#fff"
                _hover={{ backgroundColor: '#fff' }}
                _focus={{ backgroundColor: '#fff' }}
                placeholder={t(
                    'ui.analytics-mappings.validations.submenu-key.empty'
                )}
                value={data?.subMenuKey}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleSubMenuChange(event.target.value)
                }></CanopyInput>
            <CanopyInput
                height="30px"
                fontSize="md"
                backgroundColor="#fff"
                _hover={{ backgroundColor: '#fff' }}
                _focus={{ backgroundColor: '#fff' }}
                placeholder={t(
                    'ui.analytics-mappings.validations.workbook-path.empty'
                )}
                value={data?.workbookPath}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleWorkbookPathChange(event.target.value)
                }></CanopyInput>
            {total > 1 && (
                <Flex
                    height="30px"
                    alignItems="center">
                    <Tooltip
                        aria-label="delete-workbook"
                        label={t('ui.mm.tooltip.delete-workbook')}
                        placement="bottom-start"
                        hasArrow>
                        <IconButton
                            background="transparent"
                            cursor="pointer"
                            border="none"
                            color={currentColors.whiteAlpha['400']}
                            icon={<ActClose />}
                            aria-label="delete-workbook"
                            onClick={() =>
                                handleDeleteWorkbook(
                                    mappingsIndex,
                                    workbookIndex
                                )
                            }
                            variant="ghost"
                            _hover={{
                                backgroundColor: 'transparent',
                            }}
                            _focus={{
                                border: '0px',
                                backgroundColor: 'transparent',
                                outline: 'none',
                            }}
                            _active={{ border: '0px' }}
                        />
                    </Tooltip>
                </Flex>
            )}
        </HStack>
    );
}
export default WorkbookDetails;
